import { Box, Card, Typography } from "@mui/material";
import {
  useShowContext,
} from "react-admin";
import { ChefForPartyBookingTypeEnum } from "../../enums/ChefForPartyBookingTypeEnum";

//Common Styles
import {
  LeftWorkspacePanel,
  RightWorkspacePanel,
  SectionHeader,
  SectionTitle,
  WorkspacePanel,
  WorkspacePanelsWrapper,
  WorkspaceSection,
  WorkSpaceTitleRow,
} from "../../styles/commonStyles";

//Icons
import { ClockIcon } from "../Svg";

//Components
import ChefForPartyDishesList from "./ChefForPartyDishesList";
import BookByDishProposals from "./BookByDishProposals";
import PartyJsonViewer from "./PartyJsonViewer";
import ChefForPartyAssignedCookList from "./ChefForPartyAssignedCookList";
import ChefForPartyEquipmentInstructions from "./ChefForPartyEquipmentInstructions";
import ChefForPartyCustomerRating from "./ChefForPartyCustomerRating";
import CancelledPartyBanner from "./CancelledPartyBanner";
import RescheduledPartyBanner from "./RescheduledPartyBanner";
import ChefForPartyOverview from "./ChefForPartyOverview";
import CustomerInstructions from "./CustomerInstructions";
import ChefForPartyLocationDetails from "./ChefForPartyLocationDetails";
import ChefForPartyPaymentSummary from "./ChefForPartyPaymentSummary";
import ChefForPartyPaymentStatusCard from "./ChefForPartyPaymentStatusCard";
import CFPOrderSummary from "./CFPOrderSummary";
import CFPInnerDetails from "./CFPInnerDetails";
import CFPMenuIngredientStatus from "./CFPMenuIngredientStatus";
import PartyCommentsPanel from "./PartyCommentsPanel";
import HorizontalTimeline from "../Common/HorizontalTimeline";

//Colors
import { colors } from "../../styles/colors";
import CustomerPreferenceSummary from "../Customers/CustomerPreferenceSummary";
import { useCallback, useEffect, useState } from "react";
import { CustomerService } from "../../services/CustomerService";

let customerService = new CustomerService();

//const chefForPartyService = new ChefForPartyService();

// const DishList = () => {
//   const record: any = useListContext();

//   let location = useLocation();
//   let partyId = location.pathname.split("/")[2];
//   const refresh = useRefresh();

//   const [selectData, setSelectData] = useState<any>(null);
//   const [previousDish, setPreviousDish] = useState([]);

//   const [open, setOpen] = useState<boolean>(false);
//   const [category, setCategory] = useState([]);
//   const [selectCategory, setSelectCategory] = useState<any>(null);

//   const [dishes, setDishes] = useState<any>([]);
//   const [selectedDish, setSelectedDish] = useState<any>(null);

//   let [loading, setLoading] = useState(false);

//   const handleClose = () => {
//     setOpen(false);
//     setSelectData(null);
//     setSelectedDish(null);
//     setPreviousDish([]);
//   };

//   useEffect(() => {
//     if (selectCategory) {
//       chefForPartyService
//         .getAllDishesForTypeAndCategory(selectCategory, selectData?.mealType)
//         .then((data) => setDishes(data))
//         .catch((err) => setDishes([]));
//     }
//   }, [selectCategory, selectData?.mealType]);

//   useEffect(() => {
//     if (!open) return;
//     chefForPartyService
//       .getAllCategory()
//       .then((data: any) => setCategory(data))
//       .catch((err) => setCategory([]));
//   }, [open]);

//   return (
//     <>
//       <TableHead>
//         <TableRow>
//           <TableCell>Name</TableCell>
//           <TableCell>Type</TableCell>
//           <TableCell>Meal Type</TableCell>
//           {/* <TableCell></TableCell> */}
//           <TableCell>Updated At</TableCell>
//         </TableRow>
//       </TableHead>
//       {record?.data
//         ?.sort((a: any, b: any) => a?.mealType?.localeCompare(b?.mealType))
//         ?.map((e: any) => (
//           <TableRow>
//             <TableCell>{e?.dishName}</TableCell>
//             <TableCell>{e?.type}</TableCell>
//             <TableCell>{e?.mealType}</TableCell>
//             <TableCell>
//               {moment(e?.updatedAt).format("DD-MM-YYYY hh:mm A")}
//             </TableCell>
//             {/* <TableCell>
//               <Button
//                 variant={"contained"}
//                 color={"warning"}
//                 onClick={() => handleChange(e)}
//               >
//                 Change Dish
//               </Button>
//             </TableCell> */}
//           </TableRow>
//         ))}
//       <Dialog onClose={handleClose} open={open} scroll={"paper"} maxWidth="xl">
//         <DialogTitle>Edit Dish</DialogTitle>
//         <DialogContent>
//           <IconButton
//             onClick={handleClose}
//             sx={{ position: "absolute", top: 2, right: 5 }}
//           >
//             {" "}
//             <Close />{" "}
//           </IconButton>
//           <FormControl style={{ width: "180px", marginBottom: "20px" }}>
//             <InputLabel id="type">{"Cuisine"}</InputLabel>
//             <Select
//               labelId="Cuisine"
//               id="Cuisine"
//               label="Cuisine"
//               defaultValue={""}
//               onChange={(event: any) => {
//                 setSelectCategory(event.target.value);
//                 setSelectedDish(null);
//               }}
//             >
//               {category?.map((d: any) => (
//                 <MenuItem key={d.id} value={d.id}>
//                   {d.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//           <FormControl
//             style={{ width: "180px", marginBottom: "20px", marginLeft: "20px" }}
//           >
//             <InputLabel id="Dish_Name">{"Dish Name"}</InputLabel>
//             <Select
//               labelId="dishes"
//               id="dishes"
//               label="Dish Name"
//               defaultValue={""}
//               onChange={(event: any) => {
//                 setSelectedDish(event.target.value);
//               }}
//             >
//               {dishes?.map((d: any) => (
//                 <MenuItem key={d.id} value={d}>
//                   {d.name}
//                 </MenuItem>
//               ))}
//             </Select>
//           </FormControl>
//         </DialogContent>
//         <DialogActions style={{ marginTop: "12px" }}>
//           <Button
//             variant="contained"
//             disabled={loading}
//             onClick={() => {
//               if (!selectedDish) {
//                 EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
//                   message: "Select a dish to continue",
//                   type: CustomSnackbarTypes.WARNING,
//                 });
//                 return;
//               }
//               setLoading(true);
//               chefForPartyService
//                 .addDIshChefForParty(Number(partyId), {
//                   dishIds: [...previousDish, selectedDish?.id],
//                 })
//                 .then((res) => {
//                   EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
//                     message: "Added Successfully",
//                     type: CustomSnackbarTypes.SUCCESS,
//                   });
//                   refresh();
//                   handleClose();
//                 });
//               setLoading(false);
//             }}
//             size={"large"}
//           >
//             Submit
//           </Button>
//           <Button
//             variant="contained"
//             color={"error"}
//             onClick={handleClose}
//             size={"large"}
//           >
//             Cancel
//           </Button>
//         </DialogActions>
//       </Dialog>
//     </>
//   );
// };

// const CountList = () => {
//   const { record } = useShowContext();
//   let bartender = 0;
//   let waiter = 0;
//   record?.orders?.map((eachOrder: any) => {
//     if (eachOrder?.orderItems?.length !== 0) {
//       eachOrder?.orderItems.map((eachOrderItem: any) => {
//         if (eachOrderItem?.serviceAddons?.id === 1) {
//           bartender += Number(eachOrderItem?.quantity);
//         }
//         if (eachOrderItem?.serviceAddons?.id === 2) {
//           waiter += Number(eachOrderItem?.quantity);
//         }
//         return eachOrderItem;
//       });
//     }
//     return eachOrder;
//   });
//   const data = [
//     { name: "No of adults", value: record?.noOfAdults },
//     { name: "No of children", value: record?.noOfChildren },
//     { name: "No of bartender", value: bartender },
//     { name: "No of waiter", value: waiter },
//     { name: "No of starters", value: record?.noOfStarters },
//     { name: "No of main-course", value: record?.noOfMainCourse },
//     { name: "No of desserts", value: record?.noOfDesserts },
//     { name: "No of side dishes", value: record?.noOfSideDishes },
//   ];
//   return (
//     <>
//       <TableHead>
//         <TableRow>
//           <TableCell>Entity</TableCell>
//           <TableCell>Count</TableCell>
//         </TableRow>
//       </TableHead>
//       {data?.map((each) => (
//         <TableRow key={each.name}>
//           <TableCell>{each.name}</TableCell>
//           <TableCell>{each?.value}</TableCell>
//         </TableRow>
//       ))}
//       <TableRow>
//         <TableCell sx={{ fontWeight: 600 }}>{"No of Dishes"}</TableCell>
//         <TableCell sx={{ fontWeight: 600 }}>{record?.noOfDishes}</TableCell>
//       </TableRow>
//     </>
//   );
// };
// const PaymentList = () => {
//   const { record } = useShowContext();
//   const data = [
//     { name: "Total Amount", value: record?.totalAmount },
//     {
//       name: "Discount",
//       value: record?.totalDiscount ? record?.totalDiscount : "No Discount",
//     },
//     {
//       name: "Net Party Amount",
//       value: (
//         Number(record?.totalAmount) - Number(record?.totalDiscount)
//       ).toFixed(2),
//     },
//     { name: "Token", value: record?.tokenAmount },
//     { name: "Amount Paid", value: record?.amountPaid },
//     {
//       name: "Partial Payment",
//       value: record?.partialPayment
//         ? `${record?.partialPayment} (${record?.partialPaymentStatus})`
//         : "No Partial Payment",
//     },
//     { name: "Net Payable Amount", value: record?.netPayableAmount },
//   ];

//   if (record?.isCashCollected === true) {
//     data.push({
//       name: "Cash Collected",
//       value: record?.amount_to_be_collected,
//     });
//   }

//   return (
//     <>
//       <TableHead>
//         <TableRow>
//           <TableCell>Payment</TableCell>
//           <TableCell>Amount</TableCell>
//         </TableRow>
//       </TableHead>
//       {data?.map((each) => (
//         <TableRow key={each.name}>
//           <TableCell>{each.name}</TableCell>
//           <TableCell>{each?.value}</TableCell>
//         </TableRow>
//       ))}
//     </>
//   );
// };
// const PaymentListDates = () => {
//   const { record } = useShowContext();
//   return (
//     <>
//       <TableHead>
//         <TableRow>
//           <TableCell>Order Summary</TableCell>
//           <TableCell>Payment Date</TableCell>
//         </TableRow>
//       </TableHead>
//       {record?.orders?.map((each: any) => (
//         <TableRow key={each.orderSummary}>
//           <TableCell>{each?.orderSummary}</TableCell>
//           <TableCell>
//             {each?.payment?.razorpayOrder?.paymentDate
//               ? moment(each?.payment?.razorpayOrder?.paymentDate).format(
//                   "DD-MM-YYYY hh:mm A",
//                 )
//               : "-"}
//           </TableCell>
//         </TableRow>
//       ))}
//     </>
//   );
// };

const ChefForPartyMetaShow = () => {
  const { record } = useShowContext();
  let [customerPreference, setCustomerPreference] = useState<any>(null);

  const refreshData = useCallback(
             () => {
             customerService
                 .getCustomerPrefernceByCustomerId(Number(record?.customerId))
                 .then((data) => {
                 setCustomerPreference(data);
                 console.log(data);
                 })
                 .catch((err: any) => {
                 });
             },
             [record?.customerId]
         );
         
           useEffect(() => {
             refreshData();
           }, [refreshData]);

  // const copyAllDishesToClipboard = () => {
  //   const allDishesInfo = record?.dishes
  //     .sort((a: any, b: any) => a?.mealType?.localeCompare(b?.mealType))
  //     ?.map((item: any, i: number) =>
  //       i !== record?.dishes.length - 1
  //         ? ` ${item?.dishName},`
  //         : ` ${item?.dishName} .`,
  //     )
  //     .join("\n");

  //   navigator.clipboard
  //     .writeText(allDishesInfo)
  //     .then(() => {
  //       EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
  //         message: "All dish information copied to clipboard!",
  //         type: CustomSnackbarTypes.SUCCESS,
  //       });
  //     })
  //     .catch((err) => {
  //       console.error("Failed to copy text: ", err);
  //     });
  // };

  const isBookByDish = record?.bookingType === ChefForPartyBookingTypeEnum.BOOK_BY_DISH;

  return (
    <div>
      <CustomerPreferenceSummary
        customerPreference={customerPreference}
        customerId={record?.customerId}
      />
      <CancelledPartyBanner record={record} />
      <RescheduledPartyBanner record={record} />
      <WorkspacePanelsWrapper>
        <LeftWorkspacePanel>
          <ChefForPartyOverview />
          <br />
          {isBookByDish && <ChefForPartyDishesList record={record} />}
          {isBookByDish && <br />}
          {isBookByDish && <BookByDishProposals />}
          {isBookByDish && <br />}
          <ChefForPartyLocationDetails record={record} />
          <br />
          <ChefForPartyAssignedCookList cookRecord={record?.cooks} isAssignedCookMg={record?.isAssignedCookMg} />
          <br />
          {!isBookByDish && <ChefForPartyDishesList record={record} />}
          {!isBookByDish && <br />}
          <Box sx={{ mt: 2, mb: 2 }}>
            <Typography fontFamily={"inherit"} fontWeight={500} my={"8px"}>
              Cook Arrival Info
            </Typography>
            <Card
              style={{
                borderRadius: "8px",
                boxShadow: "rgba(0, 0, 0, 0.12) 0px 2px 8px",
                padding: "16px",
              }}
              elevation={0}
            >
              <Box display="grid" gridTemplateColumns="repeat(auto-fill, minmax(200px, 1fr))" gap={2}>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    Cook Arrival Status
                  </Typography>
                  <Typography
                    variant="body2"
                    fontWeight={600}
                    fontFamily="inherit"
                    sx={{
                      color:
                        record?.cookArrivalStatus === "RUNNING_LATE"
                          ? "#d32f2f"
                          : record?.cookArrivalStatus === "ON_TIME"
                          ? "#2e7d32"
                          : record?.cookArrivalStatus
                          ? "#1565c0"
                          : "text.secondary",
                    }}
                  >
                    {record?.cookArrivalStatus ?? "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    Agent Expected Arrival Time
                  </Typography>
                  <Typography variant="body2" fontFamily="inherit">
                    {record?.agentExpectedArrivalTime
                      ? new Date(record.agentExpectedArrivalTime).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) +
                        " " +
                        new Date(record.agentExpectedArrivalTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
                      : "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    ETA Arrival Time
                  </Typography>
                  <Typography variant="body2" fontFamily="inherit">
                    {record?.etaArrivalTime
                      ? new Date(record.etaArrivalTime).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" }) +
                        " " +
                        new Date(record.etaArrivalTime).toLocaleTimeString("en-US", { hour: "2-digit", minute: "2-digit", hour12: true })
                      : "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    ETA Source
                  </Typography>
                  <Typography variant="body2" fontFamily="inherit">
                    {record?.etaSource ?? "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    Cook Moving
                  </Typography>
                  <Typography variant="body2" fontFamily="inherit">
                    {record?.isCookMoving == null ? "N/A" : record?.isCookMoving ? "Yes" : "No"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    Delayed
                  </Typography>
                  <Typography
                    variant="body2"
                    fontFamily="inherit"
                    sx={{
                      color:
                        record?.isDelayed == null
                          ? "text.secondary"
                          : record?.isDelayed
                          ? "#d32f2f"
                          : "#2e7d32",
                      fontWeight: record?.isDelayed == null ? 400 : 600,
                    }}
                  >
                    {record?.isDelayed == null ? "N/A" : record?.isDelayed ? "Yes" : "No"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    Travel Distance
                  </Typography>
                  <Typography variant="body2" fontFamily="inherit">
                    {record?.travelDistance != null
                      ? `${(record?.travelDistance / 1000).toFixed(2)} km`
                      : "N/A"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    Live Map
                  </Typography>
                  <Typography variant="body2" fontFamily="inherit">
                    {record?.showLiveMap == null ? "N/A" : record?.showLiveMap ? "Available" : "Not Available"}
                  </Typography>
                </Box>
                <Box>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit">
                    Cook Coordinates
                  </Typography>
                  {record?.cookRecentCoordinates?.coordinates ? (
                    <>
                      <Typography variant="body2" fontFamily="inherit">
                        Lng: {record?.cookRecentCoordinates.coordinates[0]}, Lat:{" "}
                        {record?.cookRecentCoordinates.coordinates[1]}
                      </Typography>
                      <a
                        href={`https://www.google.com/maps/search/?api=1&query=${record?.cookRecentCoordinates.coordinates[1]},${record?.cookRecentCoordinates.coordinates[0]}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={{ fontSize: "12px" }}
                      >
                        View on map
                      </a>
                    </>
                  ) : (
                    <Typography variant="body2" fontFamily="inherit">N/A</Typography>
                  )}
                </Box>
                {/* Status Message — spans full width, inline label+value */}
                <Box sx={{ gridColumn: "1 / -1", borderTop: "1px solid #f0f0f0", pt: 1.5, display: "flex", flexWrap: "wrap", alignItems: "baseline", gap: 0.5 }}>
                  <Typography variant="caption" color="text.secondary" fontFamily="inherit" sx={{ whiteSpace: "nowrap" }}>
                    Status Message:
                  </Typography>
                  <Typography variant="body2" fontFamily="inherit">
                    {record?.statusMessage ?? "N/A"}
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Box>
          <br />
          <WorkspacePanel>
            <WorkspaceSection>
              <SectionHeader>
                <WorkSpaceTitleRow>
                  <ClockIcon color={colors.primary} height={20} width={20} />
                  <SectionTitle>Timeline</SectionTitle>
                </WorkSpaceTitleRow>
              </SectionHeader>
            </WorkspaceSection>
            <HorizontalTimeline record={record} type={"party"} />
          </WorkspacePanel>
          <br />

          <ChefForPartyCustomerRating record={record} />
        </LeftWorkspacePanel>

        <RightWorkspacePanel>

          <ChefForPartyPaymentSummary record={record} />
          <br />
          <ChefForPartyPaymentStatusCard record={record} />
          <br />
          <CFPOrderSummary record={record} />
          <br />
          <CFPInnerDetails record={record} />
          <br />
          <CFPMenuIngredientStatus record={record} />
          <br />
          <CustomerInstructions record={record} />
          <br />
          <ChefForPartyEquipmentInstructions record={record} />
          <br />
          <PartyCommentsPanel record={record} />
          <br />
          <PartyJsonViewer data={record} />
        </RightWorkspacePanel>
      </WorkspacePanelsWrapper>
      
      {/* <Stack gap={1} direction={"row"}>
        <SimpleShowLayout>
          <SimpleShowLayout>
            <FunctionField
              label="id"
              render={(record: RaRecord) => {
                if (!record?.rescheduledFrom) {
                  return <div>{record?.id}</div>;
                } else {
                  return (
                    <div>
                      {record?.id} (Rescheduled From
                      <CustomReferenceField
                        label=""
                        listName={"ChefForParty"}
                        source={"rescheduledFrom"}
                      />
                      )
                    </div>
                  );
                }
              }}
            />
            <TextField source="customerName" />
            <FunctionField label="Date" render={(record: any) => record?.date ? moment(record.date).format('DD MMM YYYY') : '-'} />
            <TextField source="time" />
            <TextField source="status" />
            <TextField source="occasion" />
            <TextField source="otp" />
            <TextField source="isCashCollected" />
            <TextField source="numberOfBurners" />
            <TextField
              label={"Required non onion garlic food"}
              source="nonOnionGarlic"
            />
            <TextField source="vegOnlyPeople" />
            <CustomReferenceField
              label="Allocator Id"
              listName={"AdminUsers"}
              source={"allocatorId"}
            />
            {record?.clientId && (
              <FunctionField
                label="Source of booking"
                render={(record: RaRecord) => {
                  if (record?.clientId === 2) {
                    return <div>CENTAURUS</div>;
                  } else if (record?.clientId === 4) {
                    return <div>CUSTOMER APP</div>;
                  } else if (record?.clientId === 9) {
                    return <div>WEBSITE</div>;
                  }
                }}
              />
            )}
            <FunctionField
              label="Created At"
              render={(record: RaRecord) =>
                `${record?.createdAt ? moment(record?.createdAt).format("DD/MM/YYYY hh:mm A") : "Not Available"}`
              }
            />
            <FunctionField
              label="Cancelled At"
              render={(record: RaRecord | undefined) =>
                `${record?.cancelledAt ? moment(record?.cancelledAt).format("DD/MM/YYYY hh:mm A") : "Not Available"}`
              }
            />
            <FunctionField
              label="Customer Tip"
              render={(record: any) =>
                record?.vendorTipDetails[0]?.amount
                  ? `${record?.vendorTipDetails[0]?.amount} (${record?.vendorTipDetails[0]?.status})`
                  : "Not Available"
              }
            />
            <FunctionField
              label="Allowed late payment"
              render={(record: RaRecord) =>
                `${record?.allowLatePayment ? "YES" : "NO"}`
              }
            />
            <ArrayField
              sortable={false}
              label="Cook Phone Number"
              source="cooks"
            >
              <Datagrid bulkActionButtons={false}>
                <FunctionField
                  label={"Name"}
                  render={(record: any) =>
                    `${record?.profile?.cookFullProfile?.firstName} ${record?.profile?.cookFullProfile?.lastName}`
                  }
                />
                <FunctionField
                  render={(record: any) => (
                    <CallButton
                      toPhoneNumber={record?.profile?.mobile}
                      userType={UserType.COOK}
                      referenceId={record?.details?.chefForPartyId}
                      referenceModelName="CHEF_FOR_PARTY"
                    />
                  )}
                />
                <FunctionField
                  label={"Type"}
                  render={(record: any) => record?.details?.type}
                />
                <FunctionField
                  label={"Allocated At"}
                  render={(record: any) =>
                    record?.details?.vendorAllocatedAt
                      ? moment(record?.details?.vendorAllocatedAt).format(
                          "DD/MM/YYYY hh:mm A",
                        )
                      : "-"
                  }
                />
              </Datagrid>
            </ArrayField>
          </SimpleShowLayout>
          <SimpleShowLayout record={record?.house}>
            <CustomReferenceField
              label="House Id"
              listName={"Houses"}
              source={"id"}
            />
            <FunctionField
              label="Address"
              render={(record: {
                address: any;
                cityName: any;
                localityName: any;
                areaName: any;
              }) =>
                [
                  record?.address,
                  record?.localityName,
                  record?.areaName,
                  record?.cityName,
                ]
                  ?.filter((each) => each !== null)
                  .join(", ")
              }
            />
            <ReferenceField source="cityId" link="show" reference="Cities">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField source="areaId" link="show" reference="Areas">
              <TextField source="name" />
            </ReferenceField>
            <ReferenceField
              source="localityId"
              link="show"
              reference="Localities"
            >
              <TextField source="name" />
            </ReferenceField>
            <CallButton
              heading={"Customer phone number"}
              toPhoneNumber={record?.customerPhone}
              userType={UserType.CUSTOMER}
              referenceId={record?.id}
              referenceModelName="CHEF_FOR_PARTY"
            />
            <FunctionField
              label="Cook Type"
              render={(record: { isAssignedCookMg: String }) =>
                `${record.isAssignedCookMg ? "MG Cook" : "Part-time"}`
              }
            />
          </SimpleShowLayout>
        </SimpleShowLayout>
        <SimpleShowLayout>
          <Table>
            <CountList />
          </Table>
        </SimpleShowLayout>
        <SimpleShowLayout
          sx={{ display: "flex", flexDirection: "column", gap: "2rem" }}
        >
          <Table>
            <PaymentList />
          </Table>
          <Table>
            <PaymentListDates />
          </Table>
        </SimpleShowLayout>
        <SimpleShowLayout sx={{ width: "450px" }}>
          <TextField source={"cancellationReason"} />
          <TextField source={"cancellationSubReason"} />
          <TextField source={"rescheduleReasons"} />
          <TextField source={"rescheduleSubReason"} />
          <Card
            style={{
              overflow: "auto",
              borderRadius: "4px",
              height: "12rem",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 3px",
            }}
            elevation={0}
          >
            <SimpleShowLayout>
              <Typography
                variant="subtitle2"
                sx={{ fontSize: "12px", fontWeight: "normal" }}
              >
                Customer Instruction
              </Typography>

              <Typography
                variant="body2"
                sx={{
                  whiteSpace: "pre-line", // 👈 keeps line breaks
                  color: record?.customerNotes
                    ? "text.primary"
                    : "text.secondary",
                  fontSize: "12px",
                }}
              >
                {record?.customerNotes || "Not Available"}
              </Typography>
            </SimpleShowLayout>
          </Card>

          <Card
            style={{
              overflow: "auto",
              borderRadius: "4px",
              height: "12rem",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 3px",
            }}
            elevation={0}
          >
            <SimpleShowLayout>
              <ArrayField emptyText="Not Available" source="allocatorComments">
                <Datagrid bulkActionButtons={false}>
                  <TextField emptyText="Not Available" source="comment" />
                  <TextField
                    emptyText="Not Available"
                    source="commenterEmail"
                  />
                  <DateField
                    emptyText="Not Available"
                    source="timestamp"
                    showTime
                  />
                </Datagrid>
              </ArrayField>
            </SimpleShowLayout>
          </Card>
          <Card
            style={{
              overflow: "auto",
              borderRadius: "4px",
              height: "12rem",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 3px",
            }}
            elevation={0}
          >
            <SimpleShowLayout>
              <ArrayField emptyText="Not Available" source="supplyComments">
                <Datagrid bulkActionButtons={false}>
                  <TextField emptyText="Not Available" source="comment" />
                  <TextField
                    emptyText="Not Available"
                    source="commenterEmail"
                  />
                  <DateField
                    emptyText="Not Available"
                    source="timestamp"
                    showTime
                  />
                </Datagrid>
              </ArrayField>
            </SimpleShowLayout>
          </Card>
          <Card
            style={{
              overflow: "auto",
              borderRadius: "4px",
              height: "12rem",
              boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 3px",
            }}
            elevation={0}
          >
            <SimpleShowLayout>
              <ArrayField emptyText="Not Available" source="customerComments">
                <Datagrid bulkActionButtons={false}>
                  <TextField emptyText="Not Available" source="comment" />
                  <TextField
                    emptyText="Not Available"
                    source="commenterEmail"
                  />
                  <DateField
                    emptyText="Not Available"
                    source="timestamp"
                    showTime
                  />
                </Datagrid>
              </ArrayField>
            </SimpleShowLayout>
          </Card>
        </SimpleShowLayout>
      </Stack> */}
      {/* <Stack>
        <SimpleShowLayout>
          <Box>
            <Typography fontFamily={"inherit"} fontWeight={500} my={"16px"}>
              Time Line
            </Typography>
            <HorizontalTimeline record={record} type={"party"} />
          </Box>
          <Box>
            <Typography fontFamily={"inherit"} fontWeight={500} my={"16px"}>
              Customer Ratings
            </Typography>
            {record?.customerRatings &&
              record?.customerRatings?.length !== 0 && (
                <TableContainer component={Paper}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">Overall Ratings</TableCell>
                        <TableCell align="center">Behaviour Rating</TableCell>
                        <TableCell align="center">Cleaniness Rating</TableCell>
                        <TableCell align="center">
                          Food Quality Rating
                        </TableCell>
                        <TableCell align="center">Comments</TableCell>
                        <TableCell align="center">Photos</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {record?.customerRatings?.map(
                        (row: any, index: number) => (
                          <TableRow key={index}>
                            <TableCell align="center" sx={{ fontWeight: 500 }}>
                              <Chip label={row?.overallRating} />
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                {row?.behaviourRating && (
                                  <Chip
                                    sx={{ mb: "4px" }}
                                    label={row?.behaviourRating}
                                  />
                                )}
                                {row?.ratingTags &&
                                  row?.ratingTags["Behavior related"]
                                    ?.length !== 0 &&
                                  row?.ratingTags["Behavior related"]?.map(
                                    (val: any, ind: number) => {
                                      return (
                                        <Box
                                          key={ind}
                                          display={"flex"}
                                          flexDirection={"column"}
                                          mb={"4px"}
                                        >
                                          <Chip label={val} />
                                        </Box>
                                      );
                                    },
                                  )}
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                {row?.cleaninessRating && (
                                  <Chip
                                    sx={{ mb: "4px" }}
                                    label={row?.cleaninessRating}
                                  />
                                )}
                                {row?.ratingTags &&
                                  row?.ratingTags["Hygiene Related"]?.length !==
                                    0 &&
                                  row?.ratingTags["Hygiene Related"]?.map(
                                    (val: any, ind: number) => {
                                      return (
                                        <Box
                                          key={ind}
                                          display={"flex"}
                                          flexDirection={"column"}
                                          mb={"4px"}
                                        >
                                          <Chip label={val} />
                                        </Box>
                                      );
                                    },
                                  )}
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              <Box>
                                {row?.foodQualityRating && (
                                  <Chip
                                    sx={{ mb: "4px" }}
                                    label={row?.foodQualityRating}
                                  />
                                )}
                                {row?.ratingTags &&
                                  row?.ratingTags["Food related"]?.length !==
                                    0 &&
                                  row?.ratingTags["Food related"]?.map(
                                    (val: any, ind: number) => {
                                      return (
                                        <Box
                                          key={ind}
                                          display={"flex"}
                                          flexDirection={"column"}
                                          mb={"4px"}
                                        >
                                          <Chip label={val} />
                                        </Box>
                                      );
                                    },
                                  )}
                              </Box>
                            </TableCell>
                            <TableCell align="center">
                              {row?.comments}
                            </TableCell>
                            <TableCell align="center">
                              <Box
                                display={"flex"}
                                justifyContent={"center"}
                                alignItems={"center"}
                                gap={"5px"}
                              >
                                {row?.photos &&
                                  row?.photos?.length !== 0 &&
                                  row?.photos?.map(
                                    (photo: any, ind: number) => (
                                      <Box sx={{ cursor: "pointer" }}>
                                        <ImagePreviewer
                                          key={ind}
                                          value={photo}
                                          width={"70px"}
                                          height={"70px"}
                                        />
                                      </Box>
                                    ),
                                  )}
                              </Box>
                            </TableCell>
                          </TableRow>
                        ),
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
          </Box>
          <CustomerRatingsImages service="CHEF_FOR_PARTY" />
        </SimpleShowLayout>
      </Stack>
      <Stack>
        <Card
          style={{
            overflow: "auto",
            borderRadius: "4px",
            boxShadow: "rgba(0, 0, 0, 0.35) 0px 1px 3px",
          }}
          elevation={0}
        >
          <SimpleShowLayout>
            <Box display={"flex"} justifyContent={"flex-end"}>
              <Button onClick={copyAllDishesToClipboard}>Copy</Button>
            </Box>
            <ArrayField emptyText="Not Available" source="dishes">
              <Table>
                <DishList />
              </Table>
            </ArrayField>
          </SimpleShowLayout>
        </Card>
        <ChefForPartyOrderListEdit />
      </Stack> */}
      {/* <JsonViewer data={record} /> */}
    </div>
  );
};

export default ChefForPartyMetaShow;
